export default __webpack_public_path__ + "static/media/13.15816fc5.png";